// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-text-right .col{text-align:center}.explain-dialog{max-width:70rem}.explain-content{height:45rem;position:absolute;padding-top:0;padding-left:0;padding-right:0}.explain-body{overflow-x:hidden;height:45rem}.explain-header{background-color:#2cb774;color:#fff}.explain-header .close,.explain-header .close:hover{color:#fff;font-size:30px;font-weight:400;text-shadow:none}", ""]);
// Exports
module.exports = exports;
